import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "LITBYYRS",
  title: defineMessage({
    id: "fig.learning.LITBYYRS.title",
    defaultMessage: `Youth literacy rate by years of schooling`,
  }),
  caption: defineMessage({
    id: "fig.learning.LITBYYRS.caption",
    defaultMessage: `Even six years of schooling do not guarantee literacy.`,
  }),
  source: defineMessage({
    id: "fig.learning.LITBYYRS.source",
    defaultMessage: `GEM Report team analysis based on household surveys`,
  }),
};
